// import Vue from 'vue'
import axios from "@/global-config/request/axios-config"
const CryptoJS = require("crypto-js");


export default {

    data() {
        return {
            publicPath: process.env.BASE_URL,
            exportFileDownloadUrl: 'https://efun.ae/public/',
            amountDecimalPlaces:3,
            feesDecimalPlaces:3,
            downloadReportRequestData:null,
            secretEncryptKey: 'test',
        }
    },
    methods: {
        async makeRequest(requestType = 'get', url, data = {}, optionalConfig = {}, showSuccessMsg = true,showErrorMsg = true,hideSpecificError=[]) {

            data.uri = this.endpointMapper(url) ? this.endpointMapper(url) : url
            url = '/'


            let responseFormat = {}
            let requestObj = null;
            switch (requestType) {
                case 'get':
                    requestObj = axios.get(url, {params: data});
                    break;

                case 'post':
                    requestObj = axios.post(url, data, optionalConfig);
                    break;

                case 'put':
                    requestObj = axios.put(url, data, optionalConfig);
                    break;

                case 'delete':
                    requestObj = axios.delete(url, data);
                    break;

                default:
                    /*if no params matches in switch case*/
                    requestObj = axios.get(url, data);
            }
            await requestObj.then(callResponse => {
                /*success*/
                responseFormat.error = false;
                responseFormat.response = callResponse;
                let code = responseFormat.response.data.code
                if (code == 200) {
                    if (showSuccessMsg) {
                        this.$toast.success(responseFormat.response.data.message, {
                            position: "top-right",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            maxToasts: 1
                        })

                    }
                }
                else if (code == 401) {

                    if(showErrorMsg){
                        this.$toast.error(responseFormat.response.data.message, {
                            position: "top-right",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            maxToasts: 1,

                        })
                    }

                    localStorage.clear();
                    if (this.$router.currentRoute.name !== 'login') {
                        this.$router.push({name: 'login'});
                    }
                    return
                }
                else {
                    // check if error for the code has been hidden then dont show any msg

                    if(hideSpecificError.includes(code)){
                        return
                    }

                    this.$toast.clear();

                    if (responseFormat.response.data.message == '') {
                        this.$toast.error('Error! An error occurred', {
                            position: "top-right",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            maxToasts: 1
                        })
                    } else {
                        this.$toast.error(responseFormat.response.data.message, {
                            position: "top-right",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            maxToasts: 1
                        })
                    }



                }

            }).catch(error => {

                let code = error.response.data.code
                if (code == 400) {
                    responseFormat.error = false;
                    responseFormat.response = error.response;

                    if (error.response.data.message == '') {
                        if(showErrorMsg) {
                            this.$toast.error('Error! An error occurred', {
                                position: "top-right",
                                timeout: 2000,
                                closeOnClick: true,
                                pauseOnFocusLoss: true,
                                pauseOnHover: true,
                                draggable: true,
                                draggablePercent: 0.6,
                                showCloseButtonOnHover: false,
                                hideProgressBar: true,
                                closeButton: "button",
                                icon: true,
                                maxToasts: 1
                            })
                        }
                    } else {
                        if(showErrorMsg) {
                            this.$toast.error(error.response.data.message, {
                            position: "top-right",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            maxToasts: 1
                        })
                        }
                    }

                } else {
                    /*error*/
                    responseFormat.error = true;
                    responseFormat.response = error;
                    // this.$toast.error('Error! An error occurred');
                }


            }).finally(() => {


            });
            return responseFormat;
        },
        isEmpty(obj) {
            for (var prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    return false;
                }
            }
            if (typeof obj.length != 'undefined') {
                if (obj.length) {
                    return false
                } else {
                    return true
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        },
        copyText(text,showToastMsg = false) {
            if (typeof (navigator.clipboard) == 'undefined') {
                var textArea = document.createElement("textarea");
                textArea.value = text;
                textArea.style.position = "fixed"; //avoid scrolling to bottom
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();

               if(showToastMsg){
                   try {
                       //var successful = document.execCommand('copy');
                       this.$toast.success('Text copied', {
                           position: "top-right",
                           timeout: 5000,
                           closeOnClick: true,
                           pauseOnFocusLoss: true,
                           pauseOnHover: true,
                           draggable: true,
                           draggablePercent: 0.6,
                           showCloseButtonOnHover: false,
                           hideProgressBar: true,
                           closeButton: "button",
                           icon: true,
                           maxToasts: 1
                       })
                   } catch (err) {
                       this.$toast.error(text, {
                           position: "top-right",
                           timeout: 2000,
                           closeOnClick: true,
                           pauseOnFocusLoss: true,
                           pauseOnHover: true,
                           draggable: true,
                           draggablePercent: 0.6,
                           showCloseButtonOnHover: false,
                           hideProgressBar: true,
                           closeButton: "button",
                           icon: true,
                           maxToasts: 1
                       })
                   }
               }

                document.body.removeChild(textArea)
                return;
            }
            navigator.clipboard.writeText(text);
           if(showToastMsg){
               this.$toast.success(text, {
                   position: "top-right",
                   timeout: 2000,
                   closeOnClick: true,
                   pauseOnFocusLoss: true,
                   pauseOnHover: true,
                   draggable: true,
                   draggablePercent: 0.6,
                   showCloseButtonOnHover: false,
                   hideProgressBar: true,
                   closeButton: "button",
                   icon: true,
                   maxToasts: 1
               })
           }
        },
        checkDataInStore(directedUrl) {

            /*check if the redirect is not from add or update then send the call
            * to the server to fetch refreshed data
            * */
            if (
                typeof this.$route.params.update == "undefined" &&
                typeof this.$route.params.add == "undefined"
            ) {
                let existingState = this.$store.state;
                // remove the item from storage so that the call will be sent again
                delete existingState[this.storageKey]
                this.$store.replaceState(existingState);
                this.url = directedUrl;
                return
            }

            if (this.$store.getters.getByKey(this.storageKey)) {
                if (
                    this.$store.getters.getByKey(this.storageKey).firstPageData
                        .noRecordFound == false &&
                    this.$store.getters.getByKey(this.storageKey).firstPageData.pagination
                        .currentPage == 1
                ) {
                    this.url = this.storageKey;
                } else {
                    this.url = directedUrl;
                }
            } else {
                this.url = directedUrl;
            }
        },
        downloadReport(requestData, uri = 'v1/generate-report') {
            requestData.uri = uri
            requestData.page = this.$store.getters.getChosenPage
            requestData.generateReport = 1
            if(requestData.exportAs == 'json'){
                requestData.jsonData = 1
            }

            this.$store.dispatch('mutateDownloadReportRequestData', requestData)

            this.$store.dispatch('triggerShowExportConfirmationModal', true)

        },
        endpointMapper(uri) {
            let uris = {}

            if (typeof (uris[uri]) != 'undefined')
                return uris[uri]
            else
                return null

        },
        removeCookie(cookieName) {
            /*
            * Note that javascript is not directly removing the session:
            * the client reads the cookie, invalidates it and sends the proper information
            * to the server, which then expires the session accordingly
            * */
            let cookieValue = "";
            let cookieLifetime = -1;
            var date = new Date();
            date.setTime(date.getTime() + (cookieLifetime * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
            document.cookie = cookieName + "=" + JSON.stringify(cookieValue) + expires + "; path=/";
        },
        customFormatDateTime(value){
           // return new Date(value).toLocaleString().replace(',',' ').replace('/','-').replace('/','-').replace(/:[^:]*$/,'')
           // return new Date(value).toLocaleString().replace(',',' ').replace('/','-').replace('/','-')
           // return new Date(value).toLocaleString([], { hour: '2-digit', minute: '2-digit',year: 'numeric', month: 'numeric', day: 'numeric' })
           return new Date(value).toLocaleString([], { hour: '2-digit', minute: '2-digit',second: '2-digit',year: 'numeric', month: 'numeric', day: 'numeric' }).replace(/(\d+)\/(\d+)\/(\d+)/, '$2-$1-$3')
        },
        stripTags(str){
            if (typeof str == 'string'){
                return str.replace(/<[^>]*>?/gm, '');
            }
            return str
            
            
        },
        calculateProcessedAndExchangeRateAmountForList(row,forExchangeRate= false){
            let actualAmount = 0
            if(row.total_amount != row.amount){
                actualAmount = row.total_amount
            }else{
                actualAmount = row.amount
            }
            let amount = parseFloat(actualAmount)
            let markup = parseFloat(row.exchange_details.markup)
            let exchangeRate = parseFloat(row.exchange_details.exchange_rate)
            exchangeRate = (parseFloat(exchangeRate) * (parseFloat(markup/100)))+ parseFloat(exchangeRate)
            if(forExchangeRate){
                return exchangeRate
            }
            let processedAmount = amount * exchangeRate
            return parseFloat(processedAmount/100).toFixed(this.amountDecimalPlaces)
        },
        modifyAmount(x,decimalPlaces = 3) {
            let internationalNumberFormat = new Intl.NumberFormat('en-US',{
                // style: 'currency',
                // currency: 'USD',
                minimumFractionDigits: decimalPlaces,
            })
            return internationalNumberFormat.format(x)


            // return x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
        },
        convertDuration(min) {
            return {
                days: Math.floor(min / 24 / 60),
                hours: Math.floor(min / 60 % 24),
                mins: Math.floor(min % 60),
            }
        },
        disableFutureDates(date) {
            // Disable dates that are after today
            return date > new Date();
        },
        formatMonthFromAPI(value) {
            if (!value) return ''

            const stringValue = String(value)

            if (stringValue.length !== 6) return ''

            const year = stringValue.substring(0, 4)
            const month = stringValue.substring(4, 6)

            const date = new Date(year, month - 1)

            return date.toLocaleString('en-US', {
                month: 'short',
                year: 'numeric'
            })
        },
        getRequestMonth(date) {
            if (!date) return null

            const [monthName, year] = date.split(' ')

            const monthIndex = new Date(`${monthName} 1, 2000`).getMonth() + 1
            const month = monthIndex.toString().padStart(2, '0')

            return `${year}${month}`
        },
        disableFutureMonths(date, allowCurrentMonth = false) {
            const today = new Date()

            const currentYear = today.getFullYear()
            const currentMonth = today.getMonth()

            const selectedYear = date.getFullYear()
            const selectedMonth = date.getMonth()

            const isFuture =
                selectedYear > currentYear ||
                (selectedYear === currentYear && selectedMonth > currentMonth)

            const isCurrent =
                selectedYear === currentYear && selectedMonth === currentMonth

            if (allowCurrentMonth) {
                return isFuture // allow current, block only future
            }

            return isFuture || isCurrent // block current + future
        },
        openNewWindow(url) {
            let screenWidth = window.screen.width;
            let screenHeight = window.screen.height;
            let windowWidth = screenWidth - (screenWidth * 0.1); // Slightly less than full width
            let windowHeight = screenHeight - (screenHeight * 0.1); // Slightly less than full height

            let newWin = window.open(
                url,
                "_blank",
                `width=${windowWidth},height=${windowHeight},top=50,left=50`
            );

            if (newWin) {
                newWin.focus(); // Brings the new window to the front
            } else {
                alert("Pop-up blocked! Please allow pop-ups for this site.");
            }
        },
        confirmationExportCallback(){
            let uri = 'v1/generate-report'
            let requestData = this.$store.state.downloadReportRequestData
            if (requestData.exportAs == 'excel') {
                uri = requestData.uri
            }
            delete requestData.uri
            this.$store.dispatch('triggerShowExportConfirmationModal', false)
            if (requestData.exportAs == 'excel' || requestData.exportAs == 'json') {
                this.$store.dispatch('exportExcelLoader', true)
            } else {
                this.$store.dispatch('exportPdfLoader', true)
            }

            if (requestData.exportAs == 'json') {
                uri = 'v1/export-transactions-json'
            }

            this.makeRequest('post', uri, requestData, {}).then(callResponse => {

                if (typeof (callResponse) != 'undefined') {
                    if (!callResponse.error) {
                        let code = callResponse.response.data.code;

                        if (code == 200) {
                            let data = callResponse.response.data.data
                            if (data && typeof (data.url) != 'undefined') {
                                window.open(data.url, "_blank");
                            }else if(data && typeof(data.file) != 'undefined'){
                                window.open(data.file, '_blank');
                            }
                        }
                    }
                }

                if (requestData.exportAs == 'excel' || requestData.exportAs == 'json') {
                    this.$store.dispatch('exportExcelLoader', false)
                } else {
                    this.$store.dispatch('exportPdfLoader', false)
                }

            });
        },
        encryptData(data) {
            // Convert the integer ID to a string
            if (typeof data === "number") {
                data = data.toString();
            }

            return CryptoJS.AES.encrypt(data, this.secretEncryptKey).toString();
        },
        decryptData(encryptedData) {
            return  CryptoJS.AES.decrypt(encryptedData, this.secretEncryptKey).toString(CryptoJS.enc.Utf8);
        },
        formatSectionName(name) {
            return name
                .replace(/([a-z])([A-Z])/g, '$1 $2') // Only add space between lowercase->uppercase
                .replace(/_/g, " ") // Replace underscores with spaces
                .replace(/\b\w/g, c => c.toUpperCase()) // Capitalize first letter of each word
                .trim();
        },
        isSuperAdmin(){
            var loginData = this.$store.getters.getByKey(
                "login"
            );
            if(loginData){
                if(loginData.row && !loginData.row.parent_user_id){
                   return true
                }
            }
            return false
        }

    }
}
